export default function fireToastEvent(type, text) {
  window.dispatchEvent(
    new CustomEvent('toast', {
      detail: {
        type,
        text
      }
    })
  );
}
